module.exports = __webpack_public_path__ + "media/images/common-nav/state-parks/arizona-515064e3f23348dd6bb3fea0e9b0be73.jpg";